import { SxStyles } from '../../../../types';
import theme from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const calculationDetailsStyles: SxStyles = {
  calculationDetails: {
    display: 'flex',
    justifyContent: 'center',
    '& .mask': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: getResponsiveSize(100),
      height: getResponsiveSize(25),
      backgroundColor: theme.palette.mainControls?.inActivegrey,
      borderRadius: '20px',
      '.toggle-group': {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        borderRadius: '30px',
      },
      '.toggle-button': {
        width: getResponsiveSize(35),
        height: getResponsiveSize(21),
        border: 'none',
        p: getResponsiveSize(8),

        '&.Mui-selected': {
          borderRadius: '20px',
          '.button-icon': {
            fill: theme.palette.neutral?.white,
          },
        },
        '&.easy.Mui-selected': {
          backgroundColor: '#00B53D',
        },
        '&.medium.Mui-selected': {
          backgroundColor: '#FFDF00',
        },
        '&.hard.Mui-selected': {
          backgroundColor: '#FF6801',
        },
        '&:not(.Mui-selected)': {
          backgroundColor: 'transparent',
          color: theme.palette.text.primary,
          borderRadius: getResponsiveSize(20),
          '.button-icon': {
            fill: '#BEBEBE',
          },
        },
      },
      '.button-icon': {
        width: getResponsiveSize(26),
        height: getResponsiveSize(16),
        transform: 'scale(1.2)',
      },
    },
  },
};
